import { http } from 'services/http';
import { endpoint } from 'services/endpoint';
import { TInvoicesApi } from './types';

export const invoices: TInvoicesApi = {
	getInvoices: (payload) =>
		http.post(endpoint.invoices.INVOICES, payload).then((response) => response.data),
	getPaymentLink: (payload) =>
		http
			.get(endpoint.invoices.FETCH_PAYMENT_LINK(payload.invoiceNumber))
			.then((response) => response.data),
	getDownloadInvoicePdf: (payload) =>
		http
			.get(endpoint.invoices.DOWNLOAD_INVOICE_PDF(payload.invoiceId), { responseType: 'blob' })
			.then((response) => response.data),
	getDownloadInvoiceCsv: (payload) =>
		http
			.get(endpoint.invoices.DOWNLOAD_INVOICE_CSV(payload.invoiceId), { responseType: 'blob' })
			.then((response) => response.data),
	getLastInvoiceStatus: () =>
		http.get(endpoint.invoices.LAST_INVOICE_STATUS).then((response) => response.data),
};
